import {
  Box,
  Flex,
  IconButton,
  useDisclosure,
  Stack,
  Collapse,
  Image,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { Container } from "@chakra-ui/react";

import FadeIn from "./FadeIn";

const NAVIGATIONS = [
  {
    name: "Oxford 3000",
    link: "/o3",
  },
  {
    name: "Legend",
    link: "/legend",
  },
  {
    name: "About",
    link: "/about",
  },
  {
    name: "How to Use",
    link: "/how-to-use",
  },
  {
    name: "Zhicheng Private School",
    link: "https://www.zhicheng.edu.sg/about",
    target: "_blank",
  },
];

const Header = () => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <FadeIn>
      <Box
        borderBottom="1px solid"
        borderBottomColor="grayTxt"
        mb="1rem"
        color="grayTxt"
      >
        <Container maxW="container.lg">
          <Flex
            as="nav"
            align="center"
            justify="space-between"
            wrap="wrap"
            w="100%"
            p={6}
            color="gray"
          >
            <Box as="a" href="/">
              <Image src="/images/logo.png" alt="Logo" maxW="200px" />
            </Box>
            <Stack
              direction="row"
              display={{ base: "none", md: "flex" }}
              alignItems="center"
              justifyContent="flex-end"
              flex="1"
            >
              {NAVIGATIONS.map((o) => {
                return (
                  <Box
                    as="a"
                    key={o.link}
                    href={o.link}
                    display="block"
                    minW="7rem"
                    target={o.target}
                  >
                    {o.name}
                  </Box>
                );
              })}
            </Stack>
            <IconButton
              variant="ghost"
              display={{ md: "none" }}
              aria-label="Open menu"
              fontSize="20px"
              color="grayTxt"
              onClick={onToggle}
              icon={
                isOpen ? (
                  <CloseIcon w={3} h={3} />
                ) : (
                  <HamburgerIcon w={5} h={5} />
                )
              }
            />
          </Flex>
        </Container>
        <Collapse in={isOpen} animateOpacity>
          <Box
            p={4}
            mt={16}
            position="absolute"
            top="0"
            left="0"
            right="0"
            zIndex="docked"
            bg="white"
          >
            <Stack spacing={4} alignItems="center">
              {NAVIGATIONS.map((o) => {
                return (
                  <a key={o.link} href={o.link}>
                    {o.name}
                  </a>
                );
              })}
            </Stack>
          </Box>
        </Collapse>
      </Box>
    </FadeIn>
  );
};

export default Header;
